<template>
  <div class="container">
    <table cellspacing="0" cellpadding="0" border="0" class="week">
      <thead>
        <tr>
          <th class="cal-th">日</th>
          <th class="cal-th">一</th>
          <th class="cal-th">二</th>
          <th class="cal-th">三</th>
          <th class="cal-th">四</th>
          <th class="cal-th">五</th>
          <th class="cal-th">六</th>
        </tr>
      </thead>
    </table>

    <div class="calendar" ref="calendar">
      <div class="cal-month" v-for="(item, index) in dateArr" :key="index">
        <h6 class="cal-mon-tit">{{ item.year + "年" + item.month + "月" }}</h6>
        <div class="cal-mon-main">
          <div class="cal-mon-day" v-for="(val, idx) in item.dayArr" :key="idx">
            <div
              class="day-box"
              :class="{
                'not-clock-in': val >= clockInRange.begDate && val <= currDate,
                'clock-in':
                  isHighLight &&
                  (clockInDate.indexOf(val) !== -1 ||
                    againClockIn.indexOf(val) !== -1),
                after: val > currDate && val <= clockInRange.endDate,
              }"
              @click="clickCalendar(val)"
            >
              <div v-if="val !== currDate">
                {{ val ? +val.substr(8, 2) : "" }}
              </div>
              <div v-if="val === currDate">今</div>
              <div
                class="tip-text"
                :class="
                  isHighLight && clockInDate.indexOf(val) !== -1
                    ? 'text-clock'
                    : ''
                "
                v-if="
                  val === clockInRange.begDate &&
                  againClockIn.indexOf(val) === -1 &&
                  restDates.indexOf(val) === -1
                "
              >
                开营
              </div>
              <div
                class="tip-text end-text"
                :class="
                  isHighLight && clockInDate.indexOf(val) !== -1
                    ? 'text-clock'
                    : ''
                "
                v-if="
                  val === clockInRange.endDate &&
                  againClockIn.indexOf(val) === -1 &&
                  restDates.indexOf(val) === -1
                "
              >
                结营
              </div>
              <div class="card-reissue" v-if="againClockIn.indexOf(val) !== -1">
                <img src="@/assets/clockin_icon_repair.png" alt="" />
              </div>
              <img
                src="@/assets/clockin_icon_repair_rest.png"
                class="rest-date"
                v-if="restDates && restDates.indexOf(val) !== -1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyDate } from '@/common/js/utils';

export default {
  props: {
    clockInRange: {
      // 打卡范围，最多跨一年 格式：{begDate: '2020-06-01', endDate: '2020-06-24'}
      validator(value) {
        if (
          !(value instanceof Object)
          && (value.begDate === undefined || value.endDate === undefined)
        ) {
          return false;
        }

        if (!verifyDate(value.begDate) || !verifyDate(value.endDate)) {
          return false;
        }

        const begDate = new Date(value.begDate);
        const endDate = new Date(value.endDate);

        if (
          begDate >= endDate
          || endDate.getFullYear() - begDate.getFullYear() > 1
        ) {
          return false;
        }

        return true;
      },
      required: true,
    },
    clockInDate: {
      // 已打卡的日期，格式：['2021/06/06', '2021/06/10']
      validator(value) {
        if (!(value instanceof Array)) {
          return false;
        }

        return value.every(item => verifyDate(item));
      },
      required: false,
      default() {
        return [];
      }
    },
    againClockIn: {
      // 补卡日期，格式：['2021/06/06', '2021/06/10']
      validator(value) {
        // 这个函数没有this
        if (!(value instanceof Array)) {
          return false;
        }

        return value.every(item => verifyDate(item));
      },
      required: false,
      default() {
        return [];
      }
    },
    restDates: {
      // 休息日，格式：['2021/06/06', '2021/06/10']
      validator(value) {
        if (!(value instanceof Array)) {
          return false;
        }

        return value.every(item => verifyDate(item));
      },
      required: false,
      default() {
        return [];
      }
    },
    isHighLight: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dateArr: [], // 需要渲染的日历数据，格式：{year: 2021, month: 6, dayArr: [undefined, '2021/06/01']}
      currDate: '', // 当前日期的字符串形式，例如：‘2021/06/06’
      scrollHeight: '',
    };
  },
  computed: {
    currentNetworkDate() {
      return this.$store.state.currentDateObj || new Date();
    }
  },
  created() {
    this.currDate = this.getCurrDateStr();

    const date = this.getAllDate();

    date.forEach((item) => {
      const yearMon = this.getShowCalendar(item.year, item.month);
      this.dateArr.push(yearMon);
    });

    const nowDate = this.currentNetworkDate;
    const year = nowDate.getFullYear();
    const month = nowDate.getMonth() + 1;

    const index = date.findIndex(
      item => item.year === year && item.month === month
    );
    if (index > 0) {
      // 默认显示当前月，当前月不是渲染的日历的第一个月份，所以需要滚动到对应的的月份
      this.scrollHeight = index * 310;
    }
  },
  mounted() {
    if (this.scrollHeight) {
      // 滚动相应高度，显示当前月
      this.$refs.calendar.scrollTop = this.scrollHeight;
    }
  },
  methods: {
    /**
     * @description 校验年份和月份的格式是否正确
     * @param {number} year 四位数年份
     * @param {number} month 月份
     * @returns 正确返回true，错误返回false
     */
    verifyYearMonth(year, month) {
      if (typeof year !== 'number' || typeof month !== 'number') {
        return false;
      }

      if (/^[1-9][0-9]{3}$/.test(year) && month >= 1 && month <= 12) {
        return true;
      }

      return false;
    },
    /**
     * @description 获取传入月份的最大天数
     * @param {number} year 四位数年份
     * @param {number} month 月份
     * @returns 成功返回天数，失败返回零
     */
    getDayNum(year, month) {
      let dayNum = 0;
      if (this.verifyYearMonth(year, month)) {
        // Date对象的构造函数接收月份索引（0-11）
        // 将月份设置为下个月且天数设置为0，Date对象将自动设置为上个月最后一天。
        const date = new Date(year, month, 0);
        dayNum = date.getDate();
      } else {
        console.error('clockInCalendar => getDayNum(): arguments error.');
      }

      return dayNum;
    },
    /**
     * @description 获取传入月份的第一天是周几（0：周日，1：周一）
     * @param {number} year 四位数年份
     * @param {number} month 月份
     * @returns 成功返回索引，失败返回-1
     */
    getWeekIdx(year, month) {
      let weekIdx = -1;
      if (this.verifyYearMonth(year, month)) {
        // Date对象的构造函数接收的是月份索引，所以要减一
        const date = new Date(year, month - 1, 1);

        weekIdx = date.getDay();
      } else {
        console.error('clockInCalendar => getWeekIdx(): arguments error.');
      }

      return weekIdx;
    },
    /**
     * @description 返回传入月份的所有日期，例如：['2021/06/01', ..., '2021/06/30']
     * @param {number} year 年份
     * @param {number} month 月份
     * @param {number} num 数组长度，最大31
     * @returns 错误返回空数组，成功返回对应长度的数组。
     */
    getNumberArr(year, month, num) {
      if (!this.verifyYearMonth(year, month)) {
        console.error(
          'clockInCalendar => getNumberArr(): arguments type error.'
        );
        return [];
      }

      if (typeof num !== 'number') {
        console.error(
          'clockInCalendar => getNumberArr(): arguments type error.'
        );
        return [];
      }

      if (num === 0) {
        return [];
      }

      if (num < 0) {
        num = Math.abs(num);
      }

      if (num > 31) {
        num = 31;
      }

      const monthStr = month > 9 ? month : `0${month}`;
      const numArr = [];
      for (let i = 1; i <= num; i++) {
        const day = i > 9 ? i : `0${i}`;

        numArr.push(`${year}/${monthStr}/${day}`);
      }

      return numArr;
    },
    /**
     * @description 根据传入的年月，返回要渲染的日历表数据
     * @param {number} year 四位数年份
     * @param {number} month 月份
     * @returns 失败返回 null，成功返回 {year: 2021, month: 6, dayArr: [undefined, '2021/06/01']}
     * (这个月第一天为周一，则dayArr第一个元素的值为undefined。如果是周二，则前两个元素的值都为undefined)
     */
    getShowCalendar(year, month) {
      if (!this.verifyYearMonth(year, month)) {
        return null;
      }

      const dayNum = this.getDayNum(year, month);
      const weekIdx = this.getWeekIdx(year, month);
      const dayArr = this.getNumberArr(year, month, dayNum);

      if (dayArr.length === 0) {
        return null;
      }

      const obj = { year, month, dayArr: [] };

      // 因为当前月的第一天不为周日，所以在前面补上对应长度的空数组
      if (weekIdx > 0) {
        const tempy = new Array(weekIdx);

        obj.dayArr.push(...tempy);
      }

      obj.dayArr.push(...dayArr);

      return obj;
    },
    /**
     * @description 获取当前日期的字符串形式，格式：'2021/06/03'
     */
    getCurrDateStr() {
      const date = this.currentNetworkDate;

      const year = date.getFullYear();

      let month = date.getMonth() + 1;
      month = month > 9 ? month : `0${month}`;

      let day = date.getDate();
      day = day > 9 ? day : `0${day}`;


      return `${year}/${month}/${day}`;
    },
    /**
     * @description 根据开营日期和结营日期返回需要渲染的年月
     * @return {array} 格式：[{year, month}]
     */
    getAllDate() {
      const beg = new Date(this.clockInRange.begDate);
      const end = new Date(this.clockInRange.endDate);

      const begYear = beg.getFullYear();
      const begMonth = beg.getMonth() + 1;
      const endYear = end.getFullYear();
      const endMonth = end.getMonth() + 1;

      // 开营日期和结营日期同年
      if (begYear === endYear) {
        // 同月
        if (begMonth === endMonth) {
          return [{ year: begYear, month: begMonth }];
        }

        // 不同月
        const dateArr = [];
        for (let i = begMonth; i <= endMonth; i++) {
          dateArr.push({
            year: begYear,
            month: i,
          });
        }
        return dateArr;
      }

      // 开营日期和结营日期不同年
      const dateArr = [];
      for (let i = begMonth; i <= 12; i++) {
        dateArr.push({
          year: begYear,
          month: i,
        });
      }

      for (let i = 1; i <= endMonth; i++) {
        dateArr.push({
          year: endYear,
          month: i,
        });
      }
      return dateArr;
    },
    clickCalendar(val) {
      if (val < this.clockInRange.begDate || val > this.currDate) {
        return;
      }

      this.$emit('myClick', val);
    }
  },
};
</script>

<style lang="stylus" scoped>
.week {
  width: 100%;

  .cal-th {
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: #999;
  }
}

.calendar {
  overflow-y: auto;
  height: 340px;

  &::-webkit-scrollbar {
    width: 0;
  }

  .cal-month {
    margin-bottom: 12px;

    .cal-mon-tit {
      width: 100%;
      font-size: 14px;
      color: #191919;
      text-align: center;
    }

    .cal-mon-main {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .cal-mon-day {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc((100% / 7));

      .day-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 8px 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        font-size: 14px;
        color: #DADADA;
        box-sizing: border-box;
      }

      .not-clock-in {
        color: #191919;
        background: rgba(231, 231, 231, 0.32);
        border: 0.5px solid #E7E7E7;
      }

      .clock-in {
        color: #fff;
        background: #FF9645;
        border: none;
      }

      .after {
        background: rgba(231, 231, 231, 0.16);
        border: 0.5px solid #E7E7E7;
      }

      .tip-text {
        font-size: 12px;
        color: #999;
        transform: scale(0.7);
      }

      .text-clock {
        font-size: 12px;
        color: #fff;
      }

      .end-text {
        color: #dadada;
      }

      .card-reissue {
        margin-top: 2px;
        width: 12px;
        height: 12px;
        background: #fff;
        border-radius: 50%;

        img {
          display: block;
          width: 100%;
        }
      }

      .rest-date {
        width: 13px;
        height: 12px;
        border: none;
      }
    }
  }
}
</style>
